goog.provide("shadow.js.shim.module$ol$geom");
goog.provide("module$shadow_js_shim_module$ol$geom");
shadow.js.shim.module$ol$geom = shadow.js.nativeProvides["ol/geom"] = shadow$bridge("ol/geom");
module$shadow_js_shim_module$ol$geom.default = shadow.js.shim.module$ol$geom;
